import * as React from "react";
import * as ReactDOM from "react-dom";

import { BotService } from "../../Generated/RestClient";

import { WebChat } from "./WebChat";

export interface WebChatPageProps extends React.Props<WebChatPage> {
    bot: BotService;
}

export class WebChatPage extends React.Component<WebChatPageProps, {}> {
    render(): JSX.Element {
        return (
            <div className={"webchat-page"}>
            <WebChat className={"bot-page-webchat"}
                bot={this.props.bot}
                authoringDirty={false}
                authoringError={false}
            /></div>);
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/WebChatPage.tsx